import { render, staticRenderFns } from "./ClientProjectsEdit.vue?vue&type=template&id=4ee71fca&"
import script from "./ClientProjectsEdit.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports